$(document).ready(function() {
  $('.checked-resource-highlight').click(function() {
    var resource_id        = $(this).val();
    var isChecked          = $(this).is(':checked');
    var highlight_video_id = $('#highlight-video-id').data('id');
    var resource_folder_id = $('#resource-folder-id').data('id');

    addResourceToHighlight(resource_id, highlight_video_id, resource_folder_id, isChecked);
  })

  function addResourceToHighlight(resource_id, highlight_video_id, resource_folder_id, isChecked) {
    $.ajax({
      type: "PUT",
      dataType:"json",
      data: { 'checked' : isChecked, 'resource_id' : resource_id, 'resource_folder_id' : resource_folder_id },
      url: `/admin/highlight_videos/${highlight_video_id}/add_or_remove_resource`,
      method: 'put',
      success: function(response){
        var color       = response.color;
        var title       = response.title;
        var description = response.description;

        $("#toast-title").attr("style", color);
        $("#toast-title").text(title);
        $("#toast-description").text(description);

        setTimeout(() => {
          $('.toast').toast('show');
        }, 150);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        $("#toast-title").attr("style", "color: red;");
        $("#toast-title").text("Error!");
        $("#toast-description").text(thrownError);

        setTimeout(() => {
          $('.toast').toast('show');
        }, 150);
      },
    });
  }
});